import { Lock } from "lucide-react";
import { useTenant } from "@/context/TenantContext";
import { Card, CardContent } from "@/components/ui/card";

export default function ConsultantRoute({ perm, children }) {
  const { can, membership } = useTenant();
  if (!membership) return null;
  if (!can(perm)) {
    return (
      <div className="max-w-lg mx-auto mt-16" data-testid="consultant-only-page">
        <Card className="border-amber-200 bg-amber-50">
          <CardContent className="p-6 text-center">
            <Lock className="w-8 h-8 text-amber-500 mx-auto mb-3" aria-hidden="true" />
            <h1 className="text-lg font-semibold text-slate-900">Area riservata al consulente</h1>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed">
              Questa analisi è riservata al consulente che segue la tua azienda.
              La tua area di lavoro è la compilazione dei dati: questionari, documenti ed evidenze.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }
  return children;
}
